import { render, staticRenderFns } from "./fixedMenu.vue?vue&type=template&id=90c77fca&scoped=true&"
import script from "./fixedMenu.vue?vue&type=script&lang=js&"
export * from "./fixedMenu.vue?vue&type=script&lang=js&"
import style0 from "./fixedMenu.vue?vue&type=style&index=0&id=90c77fca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c77fca",
  null
  
)

export default component.exports